import EditFormGroup from "components/form/EditFormGroup";
import React, { forwardRef } from "react";

export default forwardRef(function CapacityForm(
  {
    data = {},
    onChange = () => {},
    onError = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
  },
  ref
) {
  return (
    <div className="my-2">
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        onError={onError}
        type={type}
        layout={[
          {
            name: "box_count",
            label: "Total Boxes per a week (Subscription & One-Offs)",
            type: "number",
            size: "small",
            placeholder: "Limit count of subscription orders per week.",
            itemSize: { lg: 6, md: 6, sm: 12, xs: 12 },
            required: true,
          },
          {
            name: "box_count_oneoff",
            label: "Boxes per a week (One-Off)",
            type: "number",
            size: "small",
            placeholder: "Limit count of one-off orders per week.",
            itemSize: { lg: 6, md: 6, sm: 12, xs: 12 },
            required: true,
          },
          {
            name: "capacity_count",
            label: "Number of Open Week Slots",
            type: "number",
            size: "small",
            placeholder: "Type your week count",
            itemSize: { lg: 6, md: 6, sm: 12, xs: 12 },
            required: true,
          },
          {
            name: "oneoff_status",
            label: "One-off Order Availability",
            type: "switch",
            size: "small",
            placeholder: false,
            itemSize: { lg: 6, md: 6, sm: 12, xs: 12 },
            required: true,
          },
          {
            name: "emergency_stop",
            label: "Emergency Stop",
            type: "switch",
            size: "small",
            placeholder: false,
            itemSize: { lg: 6, md: 6, sm: 12, xs: 12 },
            required: true,
          },
        ]}
        isLabel
        fullWidth={true}
        spacing={2}
      />
    </div>
  );
});
